import { normalizeValue } from '../strings/normalizeValue';
import { getStableJson } from './getStableJson';

export function parseJSON<T>(value: string | undefined): T | undefined {
	const normalized = normalizeValue(value);
	if (!normalized) {
		return undefined;
	}

	try {
		return JSON.parse(normalized, getStableJson) as T;
	} catch {
		return undefined;
	}
}
